import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import Modal from '../Modal';
import { LoadingButton } from '@mui/lab';
import { Alert, Box, FormControl, MenuItem, Select, TextField } from '@mui/material';
import { FormLabelStyled } from '../../style/GlobalStyles';
import { post } from '../../api';
import { COMPANY_LIST_DETAILS } from '../../contants';

function CreateCase({ isOpen, onClose, detail, hasPersonalProducts }) {
    const [isLocalOpen, setIsLocalOpen] = useState(isOpen);
    const [localDetail, setLocalDetail] = useState({ ...detail });
    const [loading, setLoading] = useState(false);
    const { getUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const companyList = COMPANY_LIST_DETAILS(!hasPersonalProducts) || [];

    useEffect(() => {
        setIsLocalOpen(isOpen);
        setLocalDetail({ ...detail });
    }, [isOpen]);

    const handleModalClose = () => {
        onClose();
        setIsLocalOpen(false);
    };

    const handleCaseCreate = () => {
        let { hideCompanyField, ...record } = localDetail ?? {};

        record.subject = record?.subject?.trim();
        record.description = record?.description?.trim();

        if (record.subject && record.description) {
            record.contactId = userDetails.contact.id;
            // return console.log('record', record, hideCompanyField);
            handleModalClose();
            if (record.type) {
                let label = detail?.customerLabelList?.find((item) => item.label === record.type);
                record.type = label ? label.value : '';
            }

            if (record.subject === 'Request support: Tax Planning') {
                record.type = 'Decoder';
            }
            post('custom/createCase', { case: record }).then((result) => {
                let messageDetail;
                if (result.isSuccess) {
                    if (detail.callback) {
                        detail.callback(result.data.id);
                        return;
                    }

                    messageDetail = {
                        variant: 'success',
                        message: 'Your support request has been submitted successfully. A confirmation message with the case details has been sent to your PRIME mailbox for your records.',
                    };
                } else {
                    messageDetail = { variant: 'error', message: 'There was an error creating the case, please contact agent' };
                }
                const event = new CustomEvent('openToster', {
                    detail: messageDetail,
                });

                document.dispatchEvent(event);
            });
        }
    };

    const updateCaseDetails = (value, field) => {
        setLocalDetail({ ...localDetail, [field]: value });
    };

    return (
        <Modal
            modalOpen={isOpen}
            title={detail.title ? detail.title : 'Create Case'}
            subTitle={detail.subTitle ? detail.subTitle : 'Add details to create a new case'}
            hideActions={false}
            handleModalClose={handleModalClose}
            SubmitBtnUI={
                <LoadingButton loading={loading} type="button" variant="contained" onClick={handleCaseCreate} disabled={!(localDetail?.subject?.trim() && localDetail?.description?.trim())}>
                    Submit
                </LoadingButton>
            }
        >
            <FormControl fullWidth>
                <FormLabelStyled htmlFor="subject">
                    Subject <span style={{ color: 'red' }}>*</span>
                </FormLabelStyled>
                <TextField
                    id="subject"
                    type="text"
                    name="subject"
                    placeholder="Enter subject here..."
                    required
                    fullWidth
                    variant="outlined"
                    InputProps={
                        {
                            // color: 'secondary',
                        }
                    }
                    value={localDetail.subject}
                    onChange={(e) => updateCaseDetails(e.target.value, 'subject')}
                />
            </FormControl>
            {!detail?.hideCompanyField && (
                <FormControl fullWidth sx={{ mt: '1rem' }}>
                    <FormLabelStyled
                        htmlFor="companyName"
                        sx={(theme) => ({
                            '&.Mui-focused': {
                                color: theme.palette.text.secondary,
                            },
                        })}
                    >
                        Company name
                    </FormLabelStyled>
                    <Select
                        id="companyName"
                        name="companyName"
                        value={localDetail.accountId && companyList.find((item) => item.id === localDetail.accountId) ? localDetail.accountId : ''}
                        onChange={(e) => updateCaseDetails(e.target.value, 'accountId')}
                        displayEmpty
                        fullWidth
                        variant="outlined"
                        inputProps={{ id: 'companyName' }}
                        sx={(theme) => ({
                            '& .MuiSvgIcon-root': {
                                color: theme.palette.text.secondary,
                            },
                            '&.Mui-focused .MuiSvgIcon-root': {
                                color: theme.palette.primary.main,
                            },
                        })}
                    >
                        <MenuItem value="">
                            <em>Select company</em>
                        </MenuItem>
                        {companyList?.map((cCompany) => (
                            <MenuItem key={cCompany?.id} value={cCompany?.id}>
                                {cCompany?.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
            {detail?.showCustomerField && (
                <FormControl fullWidth sx={{ mt: '1rem' }}>
                    <FormLabelStyled
                        htmlFor="customerLabel"
                        sx={(theme) => ({
                            '&.Mui-focused': {
                                color: theme.palette.text.secondary,
                            },
                        })}
                    >
                        Support type
                    </FormLabelStyled>
                    <Select
                        id="customerLabel"
                        name="customerLabel"
                        value={localDetail.type || ''}
                        onChange={(e) => updateCaseDetails(e.target.value, 'type')}
                        displayEmpty
                        fullWidth
                        variant="outlined"
                        inputProps={{ id: 'customerLabel' }}
                        sx={(theme) => ({
                            '& .MuiSvgIcon-root': {
                                color: theme.palette.text.secondary,
                            },
                            '&.Mui-focused .MuiSvgIcon-root': {
                                color: theme.palette.primary.main,
                            },
                        })}
                    >
                        <MenuItem value="">
                            <em>Select support type</em>
                        </MenuItem>
                        {detail?.customerLabelList?.map((cCompanyLabel) => (
                            <MenuItem key={cCompanyLabel.label + cCompanyLabel.value} value={cCompanyLabel.label}>
                                {cCompanyLabel.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
            <FormControl fullWidth sx={{ mt: '1rem' }}>
                <FormLabelStyled htmlFor="comment">
                    Reason for request <span style={{ color: 'red' }}>*</span>
                </FormLabelStyled>
                <TextField
                    id="comment"
                    type="text"
                    name="comment"
                    multiline={true}
                    placeholder="Enter comment here..."
                    required
                    fullWidth
                    rows={4}
                    variant="outlined"
                    InputProps={
                        {
                            // color: 'secondary',
                        }
                    }
                    sx={{
                        '& .MuiInputBase-root.MuiOutlinedInput-root': {
                            p: 0,
                        },
                    }}
                    value={localDetail.description}
                    onChange={(e) => updateCaseDetails(e.target.value, 'description')}
                />
            </FormControl>

            {(detail.message || localDetail.type === 'Request physical mail forwarding') && (
                <Alert sx={{ mt: '1rem', background: '#FFFFE0', fontSize: '15px', color: '#00297A', border: '1px solid #ffcb6c' }} variant="filled" severity="warning">
                    {'Requesting a physical copy may include a forwarding fee.'}
                </Alert>
            )}
        </Modal>
    );
}

export default CreateCase;
